import classNames from 'classnames';
import React from 'react';

export function ContentContainer({ children, className }: React.PropsWithChildren<{ className?: string }>) {
    return <div className={classNames("px-5 lg:p-0 max-w-[100vw] lg:w-full  lg:w-auto", className)}>
        {children}
    </div>
}